<div
  [ngClass]="{
    'form-group': true,
    'form-group--is-last': isLast
  }"
>
  <h4 class="form-group__title" *ngIf="title">{{ title }}</h4>
  <ng-content></ng-content>
</div>
